import React, { useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import "./Navbar.css";
import Header from "./Header";

interface NavItem {
  key: string;
  path: string;
  tooltip: {
    title: string;
    subtitle: string;
  };
  icons: {
    normal: string;   // white
    inactive: string; // grey (hover)
    active: string;   // active
  };
}

const navItems: NavItem[] = [
  {
    key: "dashboard",
    path: "/dashboard",
    tooltip: {
      title: "Dashboard",
      subtitle: "Overview of your activities,create and recent data actions.",
    },
    icons: {
      normal: "/images/dashboard.png",
      inactive: "/images/inactive-dashboard.png",
      active: "/images/active-dashboard.png",
    },
  },

  {
    key: "email",
    path: "/email-verification",
    tooltip: {
      title: "Email Verification",
      subtitle: "Access Your single or bulk email verification tool.",
    },
    icons: {
      normal: "/images/normal.png",
      inactive: "/images/inactive.png",
      active: "/images/active.png",
    },
   
  },
  {
    key: "newdata",
    path: "/new-data",
    tooltip: {
      title: "New Data Requirement",
      subtitle: "Submit reqyests for fresh or custom B2B data lists.",
    },
   

    icons: {
      normal: "/images/data.png",
      inactive: "/images/inactive-data.png",
      active: "/images/active-data.png",
    },
  },
  {
    key: "enrichment",
    path: "/enrichment",
    tooltip: {
      title: "Data Enrichment",
      subtitle: "Enrich existing contacts lists with missing business details.",
    },
    icons: {
      normal: "/images/enrichment.png",
      inactive: "/images/data-inactive.png",
      active: "/images/active-enrichment.png",
    },
  },
];

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoveredKey, setHoveredKey] = useState<string | null>(null);

  const getIcon = (item: NavItem) => {
    const isActive = location.pathname.startsWith(item.path);
    const isHovered = hoveredKey === item.key;

    if (isActive) return item.icons.active;     // clicked
    if (isHovered) return item.icons.inactive;  // hover
    return item.icons.normal;                   // default
  };

  return (
    <>
      <Header />

      <div className="app-layout">
        {/* SIDEBAR */}
        <aside className="side-navbar">
          <div
            className="side-navbar-logo"
            onClick={() => navigate("/dashboard")}
          >
            <img src="/images/data-captive-logo.png" alt="Logo" />
          </div>

          {navItems.map(item => {
            const isActive = location.pathname.startsWith(item.path);

            return (
              <div
                key={item.key}
                className={`side-nav-item ${isActive ? "active" : ""}`}
                onClick={() => navigate(item.path)}
                onMouseEnter={() => setHoveredKey(item.key)}
                onMouseLeave={() => setHoveredKey(null)}
              >
                <img src={getIcon(item)} alt={item.key} />

                {/* TOOLTIP */}
                {hoveredKey === item.key  && (
                  <div className="side-tooltip">
                    <div className="tooltip-title">
                      {item.tooltip.title}
                    </div>
                    <div className="tooltip-subtitle">
                      {item.tooltip.subtitle}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </aside>

        {/* MAIN CONTENT */}
        <main className="container">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default Navbar;
